import React from "react";
import PropTypes from 'prop-types';
import CloseButton from "../../../components/Application/CloseButton";
import useCurrentUser from "../../../hooks/useCurrentUser";

export const EvaluationFormHeader = ({
  title,
  subtitle,
  email,
  onClose,
}) => {
  const { officeLogo } = useCurrentUser();

  return (
    <>
      <div className="bg-white border-b border-indigo-100 px-8 py-6 relative">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-6 w-full md:w-auto">
            <img
              src={officeLogo}
              alt="Company Logo"
              className="h-16 w-auto object-contain"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <div className="h-10 w-px bg-indigo-200 hidden md:block"></div>
            <div>
              <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
                {title || "Form"}
              </h1>
              {subtitle && (
                <p className="text-indigo-600 font-medium text-sm">{subtitle}</p>
              )}
            </div>
          </div>

          {/* <div className="flex items-center gap-4 w-full md:w-auto justify-end">
            <div className="flex items-center gap-3 bg-gray-50 px-4 py-2 rounded-lg border border-gray-100 max-w-xs w-full md:w-auto">
              <div className="p-2 bg-indigo-100 rounded-full text-indigo-600">
                <MailIcon size={20} />
              </div>
              <div className="flex flex-col overflow-hidden">
                <span className="text-xs uppercase text-gray-400 font-bold tracking-wider">
                  Applicant Email
                </span>
                <span
                  className="text-sm font-semibold text-gray-800 truncate"
                  title={displayEmail}
                >
                  {displayEmail}
                </span>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {onClose ? <CloseButton onClose={onClose} /> : null}
    </>
  );
};


EvaluationFormHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  email: PropTypes.string,
  logoSrc: PropTypes.string,
  onClose: PropTypes.func,
};

export default EvaluationFormHeader;